import { render, staticRenderFns } from "./study_closed.vue?vue&type=template&id=22d3a93c&"
import script from "./study_closed.vue?vue&type=script&lang=js&"
export * from "./study_closed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports